import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Store from '@material-ui/icons/Store';
import { Link } from 'react-router-dom';
import LocalOffer from '@material-ui/icons/LocalOffer';
import { connect } from 'react-redux';
import { getAllVendors as getCategoryList } from '../../store/actions/admin/Admin';
// core components
import GridItem from '../../components/Grid/GridItem.js';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';

import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);

const Vendors = (props) => {
  useEffect(() => {
    props.getCategoryList();
  }, []);

  const classes = useStyles();
  return (
    <GridItem xs={12} sm={6} md={3}>
      <Link style={{ textDecoration: 'none' }} to={'/admin/vendors'}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <Store />
            </CardIcon>
            <p className={classes.cardCategory}>Vendors</p>
            <h3 className={classes.cardTitle}>{props.allVendors.length}</h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              <LocalOffer />
              More Info
            </div>
          </CardFooter>
        </Card>
      </Link>
    </GridItem>
  );
};

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList())
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Vendors);
